<template>
  <div class="footer">
    <div class="footer-inner">
      <div class="footer-top">
        <div class="footer-left">
          <div class="contact-item">
            <div class="contact-label">{{ isEn ? 'Complaints' : '咨询热线' }}</div>
            <div class="contact-line"></div>
            <div class="contact-phone" v-for="(phone, i) in contactPhones" :key="i">{{ phone }}</div>
          </div>
          <div class="contact-item">
            <div class="contact-label">{{ isEn ? 'Information' : '投诉热线' }}</div>
            <div class="contact-line"></div>
            <div class="contact-phone">{{ config.complaint_phone || '0518-85912345' }}</div>
          </div>
          <div class="contact-item">
            <div class="contact-label">{{ isEn ? 'Rescue' : '救援热线' }}</div>
            <div class="contact-line"></div>
            <div class="contact-phone">{{ config.rescue_phone || '0518-85721235' }}</div>
          </div>
        </div>
        <div class="footer-right">
          <div class="footer-contact">
            <div class="time top-item">
              <img src="../assets/imgs/组 18@2x (1).png" alt="">
              <div class="info">
                <div class="main-info">{{ config.openTime || '07:00~18:00' }}</div>
                <div class="desc-info">开放时间</div>
              </div>
            </div>
            <div class="book top-item" @click="goTicket" style="cursor:pointer">
              <img src="../assets/imgs/组 18@2x (2).png" alt="">
              <div class="info">
                <div class="main-info">门票预约</div>
                <div class="desc-info">景区门票一键预定</div>
              </div>
            </div>
          </div>
          <div class="footer-media">
            <div class="media-item">
              <img :src="config.wechat_qr || defaultWechatQr" alt="" class="media-img">
              <div class="media-label">微信公众号</div>
            </div>
            <div class="media-item">
              <img :src="config.wechat_video_qr || defaultVideoQr" alt="" class="media-img">
              <div class="media-label">微信视频号</div>
            </div>
            <div class="media-item">
              <img :src="config.douyin_qr || defaultDouyinQr" alt="" class="media-img">
              <div class="media-label">抖音</div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-divider"></div>
      <img class="footer-banner" src="../assets/imgs/图层 1009@2x.png" alt="">
      <div class="footer-info">{{ config.copyright || '版权所有: 连云港市花果山风景区管理处' }}&emsp;&emsp;地址: {{ config.address || '连云港市郁林路5号' }}&emsp;&emsp;花果山游客服务热线：{{ config.contact_phone || '0518-85912345' }}&emsp;&emsp;</div>
      <div class="footer-icp">
        <iframe src="/biaoshi.html" class="gov-icon" frameborder="0" scrolling="no"></iframe>
        {{ config.icp || '苏ICP备18039045号-1' }}&emsp;&emsp;{{ config.gongan || '苏公网安备 32070502010353号' }}
      </div>
    </div>
  </div>
</template>

<script>
import { getConfig } from '../api/index'
import { currentLang } from '../utils/lang'
import defaultWechatQr from '../assets/imgs/微信公众号（小）.jpg'
import defaultVideoQr from '../assets/imgs/微信视频号（小）.jpg'
import defaultDouyinQr from '../assets/imgs/抖音（小）.jpg'

export default {
  name: 'FooterContent',
  data() {
    return {
      config: {},
      defaultWechatQr,
      defaultVideoQr,
      defaultDouyinQr,
    }
  },
  mounted() {
    this.fetchConfig()
  },
  computed: {
    isEn() { return currentLang.value === 'en' },
    contactPhones() {
      const raw = this.config.contact_phone || '0518-85723839'
      return raw.split('/').map(s => s.trim())
    },
  },
  methods: {
    async fetchConfig() {
      try {
        const res = await getConfig()
        if (res.code === 200 && res.data) {
          this.config = res.data
        }
      } catch (e) {
        console.error('获取站点配置失败:', e)
      }
    },
    goTicket() {
      const url = this.config.ticket_url || this.config.ticketUrl
      if (url) window.open(url, '_blank')
    },
  },
}
</script>

<style scoped lang="less">
  .footer{
    background: #715889;
    padding: 0.8rem 0 0.235rem 0;
    .footer-inner{
        .footer-top{
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 5.08rem 0.4rem 4rem;
        .footer-left{
          display: flex;
          gap: 0.6rem;
          .contact-item{
            .contact-label{
              font-size: 0.2rem;
              color: #F9F8F8;
            }
            .contact-line{
              width: 1.5rem;
              height: 1px;
              background: #F9F8F8;
              margin: 0.08rem 0;
            }
            .contact-phone{
              font-size: 0.27rem;
              color: #F9F8F8;
            }
          }
        }
        .footer-right{
          gap: 0.4rem;
          .footer-contact{
            display: flex;
            gap: 0.4rem;
          }
          .top-item{
            color: #fff;
            display: flex;
            align-items: center;
            img{
              width: 0.53rem;
              height: auto;
            }
            .info{
              margin-left: 0.13rem;
              .main-info{
                font-size: 0.22rem;
              }
              .desc-info{
                font-size: 0.13rem;
                margin-top: 0.02rem;
              }
            }
          }
          .book{
            .info{
              .main-info{
              }
            }
          }
          .footer-media{
            display: flex;
            justify-content: space-between;
            gap: 0.4rem;
            margin-top: 0.3rem;
          }
          .media-item{
            text-align: center;
            .media-img{
              width: 1rem;
              height: 1rem;
              display: block;
              margin: 0 auto 0.08rem;
              transition: transform 0.3s ease;
              transform-origin: bottom center;
              &:hover{ transform: scale(1.5); }
            }
            .media-label{
              font-size: 0.14rem;
              color: #F9F8F8;
            }
          }
        }
      }
      .footer-divider{
        width: 15.7rem;
        height: 0.01rem;
        background: #E1DDD7;
        margin: 0 auto;
      }
      .footer-banner{
        display: block;
        width: 6.92rem;
        height: 0.61rem;
        margin: 0 auto;
        margin-top: 0.37rem;
        margin-bottom: 0.3rem;
      }
      .footer-info{
        text-align: center;
        font-size: 0.16rem;
        color: #FFFFFF;
        margin-top: 0.15rem;

      }
      .footer-icp{
        text-align: center;
        font-size: 0.16rem;
        color: #FFFFFF;
        margin-top: 0.08rem;
        display: flex;
        align-items: center;
        justify-content: center;
        .gov-icon{
          /* width: 0.5rem;
          height: 0.5rem; */
          width: 36px;
          height: 35px;
        }
      }
    }
  }
</style>
